<template>
  <app-card
    class="active"
    :show-header="false"
    :show-footer="false"
  >
    <template #text>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="form"
      >
        <b-form>
          <ValidationProvider
            rules="required|url"
            name="Website"
          >
            <b-form-group
              slot-scope="{ errors }"
              :label="$t('Website') + ' *'"
            >
              <b-form-input
                v-model="data.AttachmentLink"
                :placeholder="$t('Website')"
                :state="errors[0] ? false : null"
                size="lg"
                type="text"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <b-form-group :label="$t('Description')">
            <b-form-input
              v-model="data.AttachmentName"
              :placeholder="$t('Description')"
              size="lg"
              type="text"
            />
          </b-form-group>
          <div class="d-flex justify-content-end">
            <app-button
              size="sm"
              class="mar-r-2"
              variant="outline-secondary"
              @click.prevent="onCancelClick"
            >
              {{$t('Cancel')}}
            </app-button>
            <app-button
              size="sm"
              type="submit"
              :disabled="invalid"
              variant="primary"
              @click.prevent="onSaveClick"
            >
              {{$t('Save')}}
            </app-button>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </app-card>
</template>

<script>
import AppCard from '@/components/htmlHelpers/AppCard'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AppButton from '@/components/htmlHelpers/AppButton'
import BaseComponent from '@/components/commentsNew/BaseComponent'
export default {
  name: 'AttachmentLinkForm',
  extends: BaseComponent,
  components: {
    AppButton,
    AppCard,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  data: function () {
    const defaultObject = {
      AttachmentLink: '',
      AttachmentName: '',
      ItemID: this.attachment.ItemID,
      ItemType: this.attachment.ItemType
    }
    const yearId = (new URLSearchParams(window.location.search)).get('yearId')
    if (yearId) {
      defaultObject.yearId = yearId
    }
    return {
      defaultObject,
      data: {}
    }
  },
  created () {
    this.data = this.attachment.id
      ? { AttachmentLink: this.attachment.attachmentLink, AttachmentName: this.attachment.attachmentName }
      : { ...this.defaultObject }
  },
  methods: {
    onCancelClick () {
      this.$emit('cancel')
    },
    onSaveClick () {
      this.$emit('save', this.data)
    }
  }
}
</script>
